<div class="fill-percent-renderer">
  <!-- track container always there to ensure text always alighed to right-->
  <div class="fill-track-container" [style.visibility]="showBar?'visible':'hidden'">
    <!-- Css will hide the track unless it exceeds the min width -->
    <div class="fill-percent-track">
      <div class="fill-percent-bar" [style.width.%]="value"></div>
    </div>
  </div>

  <div class="fill-percent-label">
    <span>{{valueFormatted}} </span>
  </div>
</div>
